import piwikMethod from '../piwikMethod';
import gaEvent from '../gaEvent';
/**
 *
 * Logs Piwik and Google Analytics events (as long as the piwik and/or GA scripts are in the HTML head).
 *
 * See [Piwik docs](https://piwik.org/docs/event-tracking/#tracking-events) and [Google Analytics docs](https://developers.google.com/analytics/devguides/collection/analyticsjs/events) for info about what items to place in `data`.
 *
 * ```js
 * import { event } from '@minerva-analytics/pantheon';
 *
 * // data has [category, action, name, value]
 * event(['click', 'button', 'view-more-button', 1]);
 * ```
 *
 * @param {Array} data - Event data
 */

var event = function event(data) {
  piwikMethod("trackEvent", data);
  gaEvent(data);
};

export default event;